import router from '@/presentation/router';

export default {
	name: 'router',
	async setup(app) {
		app.use(router);
		await router.isReady();
	},
};
